import React from "react";
import {Grid} from '@material-ui/core'

export default {
  "name": "PERSONAL AUTOMOBILE",
  description: [
    (
      <React.Fragment>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4} style={{paddingRight: 50}}>
            <img
              src={require('../../../assets/img/highway-4494907_640.jpg')}
              style={{
                borderRadius: "6px",
                boxShadow:
                  "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
                width: '100%',
                maxWidth: 600
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            National Insurance Underwriters (NIU) is a full service MGA and is an affiliate of the Nation Safe Drivers
            (NSD)
            group of companies. NIU currently manages automobile insurance program for Occidental Fire and Casualty
            Company
            of North Carolina in Colorado and Maryland. Additionally, NIU markets homeowners, renters, commercial, agent
            error and omissions and a variety of niche products nationwide.
            <br/>
            <br/>
            Our auto programs combine traditional conservative pricing and underwriting values with the latest
            technology.
            The NIU auto program provides a Web based quoting and binding system where motor vehicle records and clue
            reports are ordered prior to binding an application. This reduces additional premiums and cancellations.
            Suspense items are reduced as drivers are automatically listed as drivers or excluded. Additionally, this is
            a
            point of sale policy issuance program. The declaration page, all forms and the ID cards are printed at the
            point
            of sale so the customer leaves with their entire policy in hand.
          </Grid>
        </Grid>
      </React.Fragment>
    ),
    (
      <React.Fragment>
        <Grid container style={{padding: 10}}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{padding: 10}}>
            <b>Features</b>
            <br/>
            <ul>
              <li>Top Commissions "Some of the highest in the industry"</li>
              <li>New and Renewal business processing from quote to binding</li>
              <li>Post sale servicing- online policy inquiry, endorsement rating, forms, and status</li>
              <li> Advanced billing system allows 24/7 payment access and billing inquiry</li>
            </ul>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{padding: 10}}>
            <b>Advantages</b>
            <ul>
              <li>
                Faster binding/issuance and improved cash flow
              </li>
              <li>
                Accurate, real time online quoting 24/7
              </li>
              <li>
                Faster underwriter response and improved underwriting result
              </li>
              <li>
                Lowered operating cost through increased automation
              </li>
            </ul>
          </Grid>
        </Grid>
      </React.Fragment>
    ),
    (
      <React.Fragment>
        NIU also offers "NSD" Towing and Rental along with Emergency Road Service Assistance program. This is
        available
        on a stand alone basis or as an endorsement in some states.
        <br/>
        <br/>
        National Insurance Underwriters takes pride in providing unprecedented customer service and assistance
        to
        their
        agents and clients.
        <br/>
        <br/>
        The program is available in Colorado and Maryland - Additional states will be coming soon.
      </React.Fragment>
    )
  ]
}
